<template>
  <b-container>
    <h1>{{ $t("system.module.list") }}</h1>

    <b-row v-if="$store.getters.isAdministrator == true">
      <router-link :to="getUrlCreate()">
        <b-button size="sm">{{ $t("geral.create") }}</b-button>
      </router-link>
    </b-row>
    <b-row>
      <b-table
        ref="table"
        class="table-nowrap"
        :busy.sync="isBusy"
        :items="myProvider"
        :fields="fields"
        :filter="tableFilters"
        :filter-debounce="500"
        :per-page="tablePerPage"
        :current-page="tableCurrentPage"
      >
        <template v-slot:cell(actions)="data" v-if="$store.getters.isAdministrator == true ">
          <!-- {{data.item}} -->
          <router-link :to="getUrlEdit(data.item)" >
            <b-button size="sm" class="btn-checklist">
              {{ $t("geral.edit") }}
            </b-button>
          </router-link>
            <router-link :to="getUrlProfile(data.item)">
              <b-button size="sm" class="btn-checklist ml-2">
                {{ $t("system.module.profiles") }}
              </b-button>
            </router-link>
          <router-link v-if="data.item.id != 1 && data.item.id != 2" :to="getUrlMenu(data.item)">
              <b-button size="sm" class="btn-checklist ml-2">
                {{ $t("system.module.menu") }}
              </b-button>
            </router-link>
        </template>
        <template v-slot:cell(ativo)="data">
          {{ data.value ? "Sim" : "Não" }}
        </template>
      </b-table>
    </b-row>
    <table-pagination-props
      :currentPage.sync="tableCurrentPage"
      :pageOptions.sync="tablePageOptions"
      :perPage.sync="tablePerPage"
      :rowCount.sync="tableRowCount"
    >
    </table-pagination-props>
  </b-container>
</template>
<script>
export default {
  components: {
    FadeAlertDanger: () => import("@/components/FadeAlertDanger.vue"),
    SuccessFadeAlert: () => import("@/components/SuccessFadeAlert.vue"),
    TablePaginationProps: () =>
      import("@/components_rms/base/TablePaginationProps.vue"),
  },
  data: function () {
    return {
      alert: {
        error: "",
        success: "",
      },
      isBusy: false,
      fields: [
        {
          key: "actions",
          sortable: false,
          label: "",
          tdClass: "table-col-dinamic-width",
        },
        {
          key: "sequenceNumber",
          filterKey: "sequenceNumber",
          label: this.$t("system.module.sequenceNumber"),
          tdClass: "table-col-dinamic-width",
        },
        {
          key: "name",
          filterKey: "description",
          label: this.$t("system.module.list"),
        },
        {
          key: "active",
          filterKey: "active",
          label: "Ativo",
          sortable: true,
          formatter: (value, key, item) => {
            if (value) {
              return "Sim";
            }
            return "Não";
          },
        },
      ],
      tableFilters: [],
      tableRowCount: 0,
      tablePerPage: 10,
      tablePageOptions: [5, 10, 25, 50, 100, 150],
      tableCurrentPage: 1,
      tableSelectMode: "single",
      tableSelectedItem: [],
    };
  },
  created() {},
  computed: {},
  methods: {
    getUrlCreate() {
      return `../module/create`;
    },
    getUrlEdit(module) {
      return `../module/edit/${module.id}`;
    },
    getUrlProfile(module) {
      return `../moduleProfile/list/${module.id}`;
    },
    getUrlMenu(module) {
      return `../moduleMenu/list/${module.id}`;
    },
    myProvider(ctx, callback) {
      this.isBusy = true;

      let apiParam = {
        currentPage: this.tableCurrentPage,
        perPage: this.tablePerPage,
      };
      this.$apiScheduler
        .post("/Module/All", apiParam)
        .then((response) => {
          console.log(response);
          const items = response.data.items;
          this.isBusy = false;
          this.tableRowCount = response.data.totalItems;
          callback(items);
        })
        .catch((error) => {
          if (error.response.status == 401) {
            this.$store.dispatch("logout").then(() => {
              this.$router.push("/login");
            });
          } else {
            this.alert.error = error.message;
            this.$refs.danger.show();
            this.isBusy = false;
            this.tableRowCount = 0;
            callback([]);
          }
        });
      return null;
    },
  },
};
</script>
